import PackageList from "./components/PackageList";

function PackagePage() {
  return <PackageList />
}

export default PackagePage;
